import { UserSettings } from '../types';

export function getInitials(name: string) {
  const initials = name
    .split(' ')
    .map((part: string) => part[0])
    .join('');

  return initials.toUpperCase().slice(0, 2);
}

export function getUserInitials({
  email,
  firstName,
  lastName,
}: {
  email: string;
  firstName?: string;
  lastName?: string;
}): string {
  return firstName && lastName
    ? (firstName[0] + lastName[0]).toUpperCase()
    : email.slice(0, 2).toUpperCase();
}

export const defaultUserSettings: UserSettings = {
  dematPatientSendingProhibited: false,
  directMail: false,
  ensSendingAuthorized: false,
  immediateModeActivated: true,
  insCoverAuthorized: false,
  internalSendingKeywords: '',
  internalSendingProhibited: 'no',
  mainRecipientOnlyActivated: false,
  mdnRequestAuthorized: true,
  patientAutomaticResending: 'no',
  patientSendingProhibited: false,
  patientSendingProhibitedValue: 'no',
  postalShippingType: 'normal',
  postMailColorActivated: false,
  readyToSendAutomaticSending: false,
  sendingProhibited: false,
  sendingTemplate: 'generic',
  sendingShortcutEnabled: true,
};
